import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "wouter";
import BulletpointsPage from "@/app/bp/page";
import FileShareRoomPage from "@/app/file/[roomId]/page";
import FileSharePage from "@/app/file/page";
import LinkRedirectPage from "@/app/link/[short]/page";
import LinkSharePage from "@/app/link/page";
import Startseite from "@/app/page";
import PasswortPage from "@/app/pw/page";
import QRCodePage from "@/app/qr/page";

const ScriptsPage = React.lazy(() => import("@/app/skripte/page"));

import TextShareRoomPage from "@/app/text/[roomId]/page";
import TextSharePage from "@/app/text/page";
import TOTPCodePage from "@/app/totp/[code]/page";
import TOTPPage from "@/app/totp/page";
import ParaphrasePage from "@/app/umformulieren/page";

function App() {
	return (
		<Suspense
			fallback={
				<div className="flex min-h-screen items-center justify-center">
					<div
						aria-label="Lädt…"
						aria-live="polite"
						className="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600 dark:border-gray-600 dark:border-t-blue-400"
						role="status"
					/>
				</div>
			}
		>
			<Switch>
				{/* Map routes to the new page components */}
				<Route component={BulletpointsPage} path="/bp" />
				<Route component={ParaphrasePage} path="/umformulieren" />
				<Route component={TOTPPage} path="/totp" />
				<Route component={TOTPCodePage} path="/totp/:code" />
				<Route component={PasswortPage} path="/pw" />
				<Route component={QRCodePage} path="/qr" />
				<Route component={LinkSharePage} path="/link" />
				<Route component={LinkRedirectPage} path="/link/:short" />
				<Route component={TextSharePage} path="/text" />
				<Route component={TextShareRoomPage} path="/text/:roomId" />
				<Route component={FileSharePage} path="/file" />
				<Route component={FileShareRoomPage} path="/file/:roomId" />
				<Route component={ScriptsPage} path="/skripte" />
				<Route component={Startseite} path="/" />
				{/* Fallback redirect */}
				<Route path="/:rest*">{() => <Redirect to="/" />}</Route>
			</Switch>
		</Suspense>
	);
}

export default App;
